import { logout } from '../../api/user'
import yunLocalStorage from '@yld/yun-utils-local-storage'

const state = {
  userInfo: {}
}

const mutations = {
  SET_USER_INFO: (state, userInfo) => {
    state.userInfo = userInfo
  }
}

const actions = {
  getInfo({ commit }) {
    return new Promise((resolve, reject) => {
      const userInfo = yunLocalStorage.getStorage('prime_user_info')
      if (userInfo) {
        commit('SET_USER_INFO', userInfo)
      } else {
        commit('SET_USER_INFO', {})
      }
      resolve(userInfo)
    })
  },
  logout({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      logout().then(() => {
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
